import React from 'react';
import "./Hero.css";
import lab_icon from "../Assets/lab_icon.png"; // New lab-themed icon
import search_icon from "../Assets/search_icon.png";
import hero_image from "../Assets/medical_supplies.jpeg"; // Updated medical-themed image

const Hero = () => {
    return (
        <div className="hero">
            <div className='hero-content'>
                <div className='hero-left'>
                    <h1>Your Trusted <span>Medical & Lab Supply</span> Marketplace</h1>
                    <p className='hero-tagline'>
                        Connecting healthcare professionals and researchers with quality suppliers worldwide
                    </p>
                    
                    <div className='hero-search'>
                        <input 
                            type="text" 
                            placeholder="Search chemicals, equipment, reagents..." 
                        />
                        <button>
                            <img src={search_icon} alt="search" />
                            Search
                        </button>
                    </div>

                    <div className='hero-features'>
                        <div className='feature-item'>
                            <img src={lab_icon} alt="real-time" />
                            <span>Real-time Inventory</span>
                        </div>
                        <div className='feature-item'>
                            <img src={lab_icon} alt="suppliers" />
                            <span>Verified Suppliers</span>
                        </div>
                        <div className='feature-item'>
                            <img src={lab_icon} alt="global" />
                            <span>Global Network</span>
                        </div>
                    </div>
                </div>

                <div className='hero-right'>
                    <img src={hero_image} alt="Medical supplies" className='hero-image' />
                </div>
            </div>
        </div>
    );
}

export default Hero;